import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import retardUpdate from '../../../../lib/react/update-retarder';
import {OEMainMenuButtonsPropType} from '../../main-menu/oe-main-menu-model';
import {OEStdCapBarLayoutType, OEStdCapBarPropTypes} from './oe-std-cap-bar-model';
import OEStdCapBarBare from './oe-std-cap-bar-bare';
import OEStdCapBarTargetTypeBar from './oe-std-cap-bar-target-type-bar';
import OEStdCapBarMainMenuBar from './oe-std-cap-bar-main-menu-bar';
import OEToolbox from '../../../../lib/tools/oe-toolbox';

export default class OEStdMainMenuCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.connectFlag = false;

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            layoutType: OEStdCapBarLayoutType.min,
        };

        this.onWindowResized = this.onWindowResized.bind(this);

        this.onMiddleResize = this.onMiddleResize.bind(this);
        this.onLeftMainMenuBarResize = this.onLeftMainMenuBarResize.bind(this);
        this.onRightMainMenuBarResize = this.onRightMainMenuBarResize.bind(this);
        this.onTargetTypeBarContentResize = this.onTargetTypeBarContentResize.bind(this);

        this.onMiddleRef = this.onMiddleRef.bind(this);
        this.onTargetTypeBarContentRef = this.onTargetTypeBarContentRef.bind(this);
    }

    componentDidMount()    {
        this.onWindowResized();
        window.addEventListener('resize', this.onWindowResized);
    }

    componentWillUnmount()    {
        window.removeEventListener('resize', this.onWindowResized);
    }

    onConnect()  {
    }

    onRelease()    {
    }

    updateLayout()  {
        //if(!this.connectFlag)   return;
        
        if(!this.middleRef || !this.targetTypeBarContentRef) {
            this.setState({layoutType: OEStdCapBarLayoutType.singleRow});
            return;
        }

        if(!this.leftMainMenuBarSize)   this.leftMainMenuBarSize = {w: 0, h: 0};
        if(!this.rightMainMenuBarSize)   this.rightMainMenuBarSize = {w: 0, h: 0};

        const middleWidth = $(this.middleRef).outerWidth();
        const targetTypeBarWidth = $(this.targetTypeBarContentRef).outerWidth();

        let layoutType = OEStdCapBarLayoutType.singleRow;
        if(this.leftMainMenuBarSize.w + this.rightMainMenuBarSize.w > middleWidth) {
            layoutType = OEStdCapBarLayoutType.threeRow;
        } else if(this.leftMainMenuBarSize.w + this.rightMainMenuBarSize.w + targetTypeBarWidth > middleWidth)  {
            layoutType = OEStdCapBarLayoutType.twoRow;
        }
        
        //console.log('layoutType: ' + layoutType);
        this.setState({layoutType: layoutType});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.connectFlag = true;
        
        retardUpdate(this, () => {
            this.updateLayout();
        });
    }

    onWindowResized()   {
        this.updateLayout();
    }

    onMiddleResize(sender, size)    {
        this.updateLayout();
    }

    onLeftMainMenuBarResize(sender, size)  {
        if(OEToolbox.shallowEqual(this.leftMainMenuBarSize, size)) return;
        this.leftMainMenuBarSize = size;
        this.updateLayout();
    }

    onRightMainMenuBarResize(sender, size)  {
        if(OEToolbox.shallowEqual(this.rightMainMenuBarSize, size)) return;
        this.rightMainMenuBarSize = size;
        this.updateLayout();
    }

    onTargetTypeBarContentResize(sender, size)   {
        this.setState({targetTypeBarWidth: size.w});
        this.updateLayout();
    }

    onMiddleRef(ref)   {
        if(this.middleRef === ref) return;
        this.middleRef = ref;
        this.updateLayout();
    }

    onTargetTypeBarContentRef(ref) {
        if(this.targetTypeBarContentRef === ref) return;
        this.targetTypeBarContentRef = ref;
        this.updateLayout();
    }

    render() {
        const layoutType = this.state.layoutType === OEStdCapBarLayoutType.min ? OEStdCapBarLayoutType.singleRow : this.state.layoutType;
        
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <OEStdCapBarBare
                    className={'std-main-menu-cap-bar ' + this.props.className + ((layoutType === OEStdCapBarLayoutType.singleRow ? ' ' : ' multi-row ') + layoutType)}
                    appComponent={this.props.appComponent}
                    showMainMenuControlBtn={this.props.showMainMenuControlBtn}
                    showFullscreenBtn={this.props.showFullscreenBtn}
                    isFullscreen={this.props.isFullscreen}
                    middleElementRef={this.onMiddleRef}
                    onMiddleResize={this.onMiddleResize}
                >
                    <OEStdCapBarMainMenuBar
                        className="left-main-menu"
                        buttonClassName="light-hover-bg-border"
                        moduleId={this.props.moduleId}
                        buttons={this.props.leftMainMenuButtons}
                        onElementResize={this.onLeftMainMenuBarResize}
                        rightSpacer={layoutType === OEStdCapBarLayoutType.threeRow}
                    />

                    <OEStdCapBarTargetTypeBar
                        disabled={this.props.disabled}
                        buttons={this.props.targetTypeBar}
                        leftSpacer={true}
                        rightSpacer={true}
                        contentElementRef={this.onTargetTypeBarContentRef}
                        onContentResize={this.onTargetTypeBarContentResize}
                    />
                    
                    <OEStdCapBarMainMenuBar
                        className="right-main-menu"
                        buttonClassName="light-hover-bg-border"
                        moduleId={this.props.moduleId}
                        buttons={this.props.rightMainMenuButtons}
                        onElementResize={this.onRightMainMenuBarResize}
                        leftSpacer={layoutType === OEStdCapBarLayoutType.twoRow}
                        rightSpacer={layoutType === OEStdCapBarLayoutType.threeRow}
                    />

                </OEStdCapBarBare>
            </React.Fragment>
        );
    }
}

OEStdMainMenuCapBar.defaultProps = {
    className:                      '',
    moduleId:                       '',
    disabled:                       false,
    showMainMenuControlBtn:         true,
    showFullscreenBtn:              true,
    isFullscreen:                   false,
    targetTypeBar:                  []
};

OEStdMainMenuCapBar.propTypes = {
    className:                      PropTypes.string,
    moduleId:                       PropTypes.string,
    disabled:                       PropTypes.bool,
    showMainMenuControlBtn:         PropTypes.bool,
    showFullscreenBtn:              PropTypes.bool,
    isFullscreen:                   PropTypes.bool,
    appComponent:                   PropTypes.object,
    targetTypeBar:                  PropTypes.arrayOf(OEStdCapBarPropTypes.targetTypeButton),
    leftMainMenuButtons:            OEMainMenuButtonsPropType,
    rightMainMenuButtons:           OEMainMenuButtonsPropType,
};